import * as helpers from '../../helpers';
import { IndesignTextFieldsConfig } from './getData';
import { modifyElementContent } from '../../editableTextFields/saveData';
import constants from '../constants';

// Set min-height property equal line-height to all empty paragraphs for proper display in Reader
const modifyEmptyParagraphs = (fieldElement: HTMLElement): void => {
	const emptyParagraphs = [...fieldElement.querySelectorAll('p')].filter(p => !p.innerText);

	emptyParagraphs.forEach((p) => {
		if (p.style.minHeight === 'auto') {
			p.style.minHeight = p.style.lineHeight;
		}
	});
};

export default (htmlDocument: HTMLDocument, fields: IndesignTextFieldsConfig[]): void => {
	fields.forEach(({ id, content, isEditedFromBackoffice }) => {
		if (!isEditedFromBackoffice) {
			return;
		}

		const fieldElement = htmlDocument.querySelector(`#${id}`) as HTMLElement;

		if (fieldElement) {
			helpers.setElementIsEdited(fieldElement);
			const innerDiv = fieldElement.querySelector('div') as HTMLElement;
			const scale = helpers.getScaleFromStyle(innerDiv.style);
			const shouldRemoveScale = helpers.hasMaxFontSize(content, scale);

			if (shouldRemoveScale) {
				const { style: { transform, width, height } } = innerDiv;
				innerDiv.style.transform = (transform as string).replace(/scale\((.+?)\)/, '');
				innerDiv.style.width = `${helpers.getNumberFromString(width as string) * scale}px`;
				innerDiv.style.height = `${helpers.getNumberFromString(height as string) * scale}px`;
			}

			const modifiedContent = shouldRemoveScale
				? content
				: helpers.getStylesWithScaledNumbers(content, 1 / scale);

			innerDiv.innerHTML = modifiedContent;
			modifyElementContent(fieldElement, modifyEmptyParagraphs);

			const parentElement = fieldElement.closest(`[id*=${constants.parentContainerId}]:not([class*=${constants.textFieldClassName}])`);

			if (parentElement) {
				const linkElement = parentElement.querySelector('a');

				if (linkElement && helpers.isEditableButton(linkElement)) {
					parentElement.classList.add(constants.editableButtonClassName);
				}
			}
		}
	});
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/editableTextFields/saveData.ts